import { useState, useRef, useCallback } from 'react';

const useBlockOperationDialog = (handleConfirmation, isBlocked) => {
  const [showBlockOperationDialog, setShowBlockOperationDialog] = useState(false);
  const pendingAdvanceCallbackRef = useRef(null);

  const handleRequestBlockOperationCheck = useCallback((advanceCallback) => {
    pendingAdvanceCallbackRef.current = advanceCallback;
    setShowBlockOperationDialog(true);
  }, []);

  const handleBlockOperationConfirm = useCallback(() => {
    pendingAdvanceCallbackRef.current?.();
    pendingAdvanceCallbackRef.current = null;
  }, []);

  const handleShowConfirmationSummary = useCallback((value) => {
    if (isBlocked) {
      handleRequestBlockOperationCheck(() => handleConfirmation(value));
    } else {
      handleConfirmation(value);
    }
  }, [handleConfirmation, handleRequestBlockOperationCheck, isBlocked]);

  const blockOperationDialogProps = {
    open: showBlockOperationDialog,
    onClose: () => setShowBlockOperationDialog(false),
    onConfirm: handleBlockOperationConfirm,
  };

  return {
    handleShowConfirmationSummary,
    blockOperationDialogProps,
    isBlocked,
  };
};

export default useBlockOperationDialog;
